<template>
    <b-col cols="12" sm="12" id="main" ref="main">
        <!-- Botón de alertas -->
        <b-btn class="btnMo2" variant="info" @click="openNavAlertas()">
            <feather type="align-justify" class="feather-sm mr-2"></feather>Listado de alertas
        </b-btn>

        <!--Mapa-->
        <l-map ref="map" id="mapaStyle" class="layered box mt-1 mb-2" :zoom="zoom" :center="center"
            style="border-radius: 15px; overflow: hidden;">
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        </l-map>

        <!-- Menú de Alertas-->
        <b-card id="mySidenavDis" ref="mySidenavDis" class="sidenav bg-ligth layered box">
            <b-col cols="12">
                <a style="margin-top: -70px;" href="javascript:void(0)" class="closebtn" @click="closeNavDis()"
                    title="Cerrar">
                    <feather id="btnX" type="arrow-right-circle"></feather>
                </a>
            </b-col>
            <b-btn v-if="!useFilter" class="mb-1 mt-5 d-flex align-items-center justify-content-center" variant="info"
                style="color: white; margin-top: -20px !important; margin-bottom: 30px !important;" @click="filters">
                <feather type="sliders" class="feather-sm mr-2"></feather>Filtro
            </b-btn>
            <b-btn v-if="useFilter" class="mb-3 mt-5 d-flex align-items-center justify-content-center" variant="info"
                style="color: white; margin-top: -20px !important;" @click="filters">
                <feather type="sliders" class="feather-sm mr-2"></feather>Ocultar filtro
            </b-btn>

            <div v-if="useFilter">
                <b-col cols="12" sm="12">
                    <b-form-group id="input-group-3">
                        <b-form-select id="filtroAlerta" v-model="alertsModel" :options="alertsTypes" required>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </div>

            <b-table responsive class="mb-0 border-bottom border-left border-right" head-variant="info" borderless
                striped hover :items="alerts" :fields="alertHeader" :current-page="currentPageA" :per-page="perPageA"
                :filter="alertsModel" empty-filtered-text="No se encontraron resultados para su búsqueda." show-empty
                sort-icon-left @filtered="onFiltered">
                <template #empty>
                    <div style="text-align: center">
                        <span>No se encontraron registros.</span>
                    </div>
                </template>

                <template #empty-filtered>
                    <div style="text-align: center">
                        <span>No se encontraron resultados para su búsqueda.</span>
                    </div>
                </template>

                <template #cell(Alertas)="item">
                    <div class="d-flex align-items-center mt-0">
                        <b-img v-if="item.item.tipo == 'Batería baja'" src="/assets/img/iconoBateriaBaja.svg"
                            class="rounded-circle" style="width: 14%"></b-img>
                        <b-img v-if="item.item.tipo == 'Impacto'" src="/assets/img/iconoImpacto.svg"
                            class="rounded-circle" style="width: 14%"></b-img>
                        <b-img v-if="item.item.tipo == 'Geocerca'" src="/assets/img/iconoGeocerca.svg"
                            class="rounded-circle" style="width: 14%"></b-img>
                        <b-img v-if="item.item.tipo == 'Velocidad'" src="/assets/img/iconoVelocidad.svg"
                            class="rounded-circle" style="width: 14%"></b-img>
                        <b-img v-if="item.item.tipo == 'Movimiento'" src="/assets/img/iconoMovimiento.svg"
                            class="rounded-circle" style="width: 14%"></b-img>
                        <b-img v-if="item.item.tipo == 'Auxilio'" src="/assets/img/iconoAuxilio.svg"
                            class="rounded-circle" style="width: 14%"></b-img>
                        <b-avatar v-if="
                            (item.item.tipo == 'Configuración') &
                            (item.item.link != 'Reinicio de fábrica')
                        " :variant="'secondary'" class="rounded-circle">
                            <feather :type="'settings'" class="feather-sm" style="color: white"></feather>
                        </b-avatar>
                        <b-avatar v-if="
                            (item.item.tipo == 'Configuración') &
                            (item.item.link == 'Reinicio de fábrica')
                        " :variant="'danger'" class="rounded-circle">
                            <feather :type="'settings'" class="feather-sm" style="color: white"></feather>
                        </b-avatar>
                        <div v-if="item.item.tipo != 'Geocerca' && item.item.tipo != 'Configuración'
                        " class="ml-2 w-75">
                            <h6 class="fw-medium mb-2">{{ item.item.tipo }}</h6>
                            <h6 class="text-truncate d-block text-muted mb-0">
                                {{ item.item.descripcionAlerta }}
                            </h6>
                            <h6 class="text-truncate d-block text-muted mb-0">
                                Latitud: {{ Number.parseFloat(item.item.latitud).toFixed(7) }}
                            </h6>
                            <h6 class="text-truncate d-block text-muted mb-0">
                                Longitud: {{ Number.parseFloat(item.item.longitud).toFixed(7) }}
                            </h6>
                            <h6 class="text-truncate d-block text-muted mb-0">
                                Velocidad: {{ Number.parseFloat(item.item.velocidad).toFixed(2) }} km/h
                            </h6>
                            <h6 class="text-truncate d-block text-muted mb-0">
                                Batería: {{ item.item.bateria }}
                            </h6>
                            <div class="row mt-1">
                                <b-col cols="5">
                                    <h6 class="text-muted mb-0 alertas">{{ item.item.hora }}</h6>
                                </b-col>
                                <b-col cols="7">
                                    <h6 v-if="item.item.fecha != currentDate" class="text-muted mb-0 alertas">
                                        {{ item.item.fecha }}
                                    </h6>
                                    <h6 v-if="item.item.fecha == currentDate" class="text-muted mb-0 alertas">Hoy
                                    </h6>
                                </b-col>
                            </div>
                        </div>
                        <div v-if="item.item.tipo == 'Configuración'" class="ml-2 w-75">
                            <h6 class="fw-medium mb-2">{{ item.item.tipo }}</h6>
                            <h6 class="text-truncate d-block text-muted mb-0">
                                {{ item.item.descripcionAlerta }}
                            </h6>
                            <h6 class="text-truncate d-block text-muted mb-0">
                                {{ item.item.link }}
                            </h6>
                            <div class="row mt-1">
                                <b-col cols="5">
                                    <h6 class="text-muted mb-0 alertas">{{ item.item.hora }}</h6>
                                </b-col>
                                <b-col cols="7">
                                    <h6 v-if="item.item.fecha != currentDate" class="text-muted mb-0 alertas">
                                        {{ item.item.fecha }}
                                    </h6>
                                    <h6 v-if="item.item.fecha == currentDate" class="text-muted mb-0 alertas"> Hoy
                                    </h6>
                                </b-col>
                            </div>
                        </div>
                        <div v-if="item.item.tipo == 'Geocerca'" class="ml-2 w-75">
                            <h6 class="fw-medium mb-2">{{ item.item.tipo }}</h6>
                            <h6 class="text-truncate d-block text-muted mb-0">
                                {{ item.item.descripcionAlerta }}
                            </h6>
                            <h6 class="text-truncate d-block text-muted mb-0">
                                Latitud: {{ Number.parseFloat(item.item.latitud).toFixed(7) }}
                            </h6>
                            <h6 class="text-truncate d-block text-muted mb-0">
                                Longitud: {{ Number.parseFloat(item.item.longitud).toFixed(7) }}
                            </h6>
                            <h6 class="text-truncate d-block text-muted mb-0">
                                Geocerca: {{ item.item.link }}
                            </h6>
                            <div class="row mt-1 mb-0" style="margin-top: -20px;">
                                <b-col cols="5">
                                    <h6 class="text-muted mb-0 alertas">{{ item.item.hora }}</h6>
                                </b-col>
                                <b-col cols="7">
                                    <h6 v-if="item.item.fecha != currentDate" class="text-muted mb-0 alertas">
                                        {{ item.item.fecha }}
                                    </h6>
                                    <h6 v-if="item.item.fecha == currentDate" class="text-muted mb-0 alertas"> Hoy
                                    </h6>
                                </b-col>
                            </div>
                        </div>

                        <div>
                            <span v-if="!item.item.select && item.item.tipo !== 'Configuración'"
                                @click="verAlertas(item.item)" v-b-tooltip.hover title="Ver">
                                <feather type="eye" class="feather-sm mr-2"></feather>
                            </span>

                            <span v-if="item.item.select && item.item.tipo !== 'Configuración'"
                                @click="verAlertas(item.item)" v-b-tooltip.hover title="Ocultar">
                                <feather type="eye-off" class="feather-sm mr-2"></feather>
                            </span>
                        </div>
                    </div>
                </template>
            </b-table>
            <div class="mb-3 mt-2">
                <b-pagination v-model="currentPageA" :total-rows="totalRowsA" :per-page="perPageA" align="center"
                    class="my-0" first-number last-number></b-pagination>
            </div>
        </b-card>
        <!--FIN Menú de Alertas-->
    </b-col>
</template>


<script>
// === Importación de Servicios ===
import PosicionesDataService from "../../../services/PosicionesDataService";
import AlertasDataService from "../../../services/AlertasDataService";
import Jwt from "../../../services/Jwt";

// === Importación de plugins ===
import GoogleMap from "../../../components/GoogleMap";
import { validationMixin } from "vuelidate";
import L from "leaflet";
import "leaflet.markercluster";
import {
    LMap, LTileLayer, LMarker, LPopup
} from "vue2-leaflet";
import LControlFullscreen from "vue2-leaflet-fullscreen";

import validar from "@/controllers/dispositivoTokenController";

/** Capacitor Device API para obtener datos del dispositivo */
import { Device } from '@capacitor/device';
import { destruirAlerta, generalSweetAlert } from "../../../utils/Utils"
/** Obtiene información relevante del cliente. */
const logDeviceInfo = async (info) => {
    try {
        /** Comunicador entre cliente y servidor. */
        const userAgent = navigator.userAgent;
        /** Dispositivo que se esta compartiendo. */
        const device = info;

        /** Id del dispositivo del cliente. */
        const uuidDevice = await Device.getId();
        const deviceId = JSON.stringify(uuidDevice.uuid).slice(1, -1);

        /** Sistema operativo del cliente. */
        const deviceInfo = await Device.getInfo();
        const deviceOs = JSON.stringify(deviceInfo.operatingSystem).slice(1, -1);

        /** Nombre del dispositivo del cliente. Solo usada para smartphones 
        * Android superiores a 7.1 y en IOS superiores a 16. 
        * Por ejemplo: "John's iPhone".
        */
        const deviceName = (deviceOs === 'windows' || deviceOs === 'mac') ? '' : JSON.stringify(deviceInfo.name);

        /** El dispostivo se encuentra emulado o virtualizado ? */
        const isVirtual = deviceInfo.isVirtual ? ', se encuentra virtualizado.' : '';

        /**
        * Función encargada de retornar el navegador y la versión con la cual
        * se está accediendo al link del dispositivo compartido.
        */
        function obtenerNavegador() {
            const browsers = {
                Firefox: /Firefox\/([0-9.]+)/,
                Chrome: /Chrome\/([0-9.]+)/,
                Safari: /Version\/([0-9.]+).*Safari/,
                Edge: /Edge\/([0-9.]+)/,
                Opera: /(Opera|OPR)\/([0-9.]+)/,
                'Internet Explorer': /(Trident\/.*rv:|MSIE )([0-9.]+)/
            };

            for (const browser in browsers) {
                const match = userAgent.match(browsers[browser]);
                if (match && match.length > 1) {
                    return `${browser}/${match[1]}`;
                }
            }
            return 'Navegador desconocido';
        }

        /**
        * Funcion encargada de obtener la información del dispositivo tal como:
        * S.O, versión y modelo.
        */
        function obtenerInfoDispositivo() {
            let deviceName = 'Equipo desconocido';
            const computerMatches = userAgent.match(/\(([^)]+)\)/);
            if (computerMatches && computerMatches.length > 1) {
                deviceName = computerMatches[1];
            }
            return deviceName;
        }

        /**  Direccion ip pública del dispositivo que accede al enlace. */
        let ipAddress;
        const axios = require('axios');
        try {
            const { data } = await axios.get('https://api.ipify.org?format=json');
            ipAddress = data.ip;
        } catch (error) {
            console.error("ip desconocida: ", error)
            ipAddress = 'Ip desconocida'
        }

        /** Almacena el navegador previamente obtenido. */
        const navegador = obtenerNavegador();
        /** Almacena la informacion relevante del dispositvo previamente obtenida. */
        const infoDevice = obtenerInfoDispositivo();

        /** Accion para la bitacora */
        let accion = `Compartir-link: Se accedió al dispositivo compartido: ${device} desde el navegador ${navegador}, con la dirección ip ${ipAddress} ` +
            `a través del dispositivo ${deviceName} ${infoDevice} con identificador ${deviceId}${isVirtual}`;

        /** Contiene la accion de acceso. */
        let data = {
            usuario: { matricula: 'Invitado', id: 'Invitado' },
            accion: accion,
            fechaCreacion: new Date(),
            tipo: 'configuracion',
        };
        console.warn("data para bitacora : ", data)
        /** Se registra la informacion del cliente */
    } catch (err) {
        console.error("Error crítico en logDeviceInfo:", err);
    }


};

/** Modificar la ruta de los iconos */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-black-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon-black.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    spritesheet: require("leaflet-draw/dist/images/spritesheet.png"),
});

var MarkerIcon = L.Icon.extend({
    options: {
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        iconSize: [40, 76],
        shadowSize: [45, 45],
        iconAnchor: [20, 57],
        shadowAnchor: [15, 45],
        popupAnchor: [0, -32]
    },
});

var blueIcon = new MarkerIcon({
    iconUrl: "/assets/img/dispositivo-estatico-redondo.svg",
}),
    redIcon = new MarkerIcon({
        iconUrl: "/assets/img/dispositivo-fuera-de-linea-redondo.svg",
    }),
    greenIcon = new MarkerIcon({
        iconUrl: "/assets/img/dispositivo-mov-redondo.svg",
    })

/** Función encargada de asignar la imagen correspondiente al estado actual del dispositivo.
* @param estado del dispositivo.
* @returns imagen representativa del estado del dispositivo.
*/
function colorPorEstado(estado) {
    switch (estado) {
        case "EST":
            return blueIcon;
        case "MOV":
            return greenIcon;
        case "OFF":
        default:
            return redIcon;
    }
}

/** Funcion encargada de obtener el tiempo de estadía (sin movimiento)
* del dispositivo.
* @param segundos
* @returns tiempo de estadía
*/
function formatoEstadia(segundos) {
    let segs,
        dias,
        horas,
        min,
        cad = "No aplica";

    segs = segundos;
    if (segs == null || segs <= 60) { // si el tiempo de estadía es menor a un minuto o null, No aplica
        return cad;
    } else {
        cad = "";
    }
    if (segs > 86400) {
        //Días
        dias = Math.floor(segs / 86400);
        segs -= dias * 86400;
        cad += dias + " días ";
    }
    if (segs > 3600) {
        //Horas
        horas = Math.floor(segs / 3600);
        segs -= horas * 3600;
        cad += horas + " horas ";
    }
    if (segs > 60) {
        //Minutos
        min = Math.floor(segs / 60);
        segs -= min * 60;
        cad += min + " minutos ";
    }
    if (segs > 0) {
        //Segundos
        cad += segs + " segundos.";
    }
    return cad;
}

export default {
    name: "Ubicación",
    mixins: [validationMixin],
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LControlFullscreen,
        GoogleMap,
    },
    computed: {

    },
    data() {
        return {
            // === Variables para asignar a propiedades de componentes === //
            /** Variable encargada de verificar si se aplicará filtrado en las alertas obtenidas del dispositivo. */
            useFilter: false,
            /** Variable que contendrá los tipos de alertas generadas por el dispositivo. */
            alertsModel: null,
            /** Variable encarga de asignar el título a la tabla de alertas, este valor es constante. */
            alertHeader: [{}, "Alertas"],
            /** Contiene el número de la página principal de la tabla de alertas. */
            currentPageA: 1,
            /** Cantidad de filas que se mostrarán en la tabla de alertas */
            perPageA: 5,
            /** Variable que almacena la fecha actual del sistema */
            currentDate: "",
            /** Icono de batería baja */
            batteryIcon: null,
            /** Icono de movimiento */
            movementIcon: null,
            /** Icono de geocerca */
            geofenceIcon: null,
            /** Icono de velocidad */
            speedIcon: null,
            /** Icono de impacto */
            shockIcon: null,
            /** Icono de auxilio */
            aidIcon: null,
            /** Lista de las alertas junto con sus propiedades */
            alertsTypes: [
                { text: "Todas", value: null },
                { text: "Batería baja", value: "Batería baja" },
                { text: "Configuración", value: "Configuración" },
                { text: "Geocerca", value: "Geocerca" },
                { text: "Impacto", value: "Impacto" },
                { text: "Movimiento", value: "Movimiento" },
                { text: "Velocidad", value: "Velocidad" },
                { text: "Auxilio", value: "Auxilio" }
            ],

            // === Propiedades para el mapa === //
            /** Propiedad zoom del mapa */
            zoom: 4.6,
            /** Punto geográfico que será el centro visual del mapa */
            center: L.latLng(22.63429269, -101.42578125),
            /** URL de la capa visual del mapa */
            url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
            /** Atribución del mapa */
            attribution: '&copy; <a href="http://osm.org/copyright"></a> contributors',
            /** Variable para error en el mapa */
            error: { mapa: "" },
            /** Propiedad para mostrar las alertas agrupadas dentro del mapa */
            //markers: L.markerClusterGroup(),
            markers: null,

            // === Variables usadas en métodos === //
            /** Lista que almacena las alertas generadas por el dispositivo. */
            alerts: [],
            /** Lista con las alertas representadas en el mapa */
            alertList: [],
            /** Total de filas (numero total de alertas) que contendrá la tabla */
            totalRowsA: 1,
            /** Contiene el intervalo de tiempo en el que se estarán buscando alertas nuevas */
            alertsInterval: null,
            /** Verifica si se han generado alertas nuevas */
            loadAlerts: false,
            /** Contiene el intervalo de tiempo en el que se estará actualizando la ubicación del dispositivo */
            deviceInterval: null,
            /** Verifica si se han cargado posiciones nuevas para el dispositivo */
            loadNewPositions: false,
            /** Contiene la referencia del dispositivo seleccionado */
            deviceSelected: null,
            /** Nombre del dispositivo que se esta monitoreando */
            name: "",
            /** Posición del dispositivo */
            devicePosition: null,
            /** Variable auxiliar para almacenar una posición nueva del dispositivo */
            devicePositionAux: null,
            /** Variable encargada de almacenar la acción generada por el usuario en el sistema */
            accion: '',

            timeoutId: null

        };
    },
    created() {
        // Al abrir la pestaña
        localStorage.setItem("esCompartirLink", "true");

        // Cuando se cierra la pestaña, quitarlo
        window.addEventListener("beforeunload", () => {
            localStorage.removeItem("esCompartirLink");

        });

        destruirAlerta();

    },
    mounted() {

        this.$nextTick(() => {
            setInterval(this.validacion, 1000)
            this.currentDate = new Date().toJSON().slice(0, 10).replaceAll("-", "/");
            if (sessionStorage.alerta == "true") {
                this.openNavAlertas();
                sessionStorage.setItem("alerta", "false");
            }
            /** Referencia del mapa */
            const map = this.$refs.map.mapObject;

            this.markers = L.markerClusterGroup();
            map.addLayer(this.markers);

            L.tileLayer("http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", {
                subdomains: ["mt0", "mt1", "mt2", "mt3"],
                maxZoom: 20,
                attribution: "GoogleMaps",
            }).addTo(map);
            map.zoomControl.setPosition("bottomright");
            map.addControl(
                new L.Control.Fullscreen({
                    position: "bottomright",
                })
            );
            // === Se crea el componente leyenda para el mapa === //
            /** Verifica si la leyenda del mapa se encuentra abierta*/
            let isViewLegend = false;
            /** Componente principal de la leyenda del mapa */
            var legendTop = L.control({ position: "bottomleft" });
            legendTop.onAdd = function (map) {
                var div = L.DomUtil.create("div", "info legend");
                div.innerHTML += '<img id="legend" alt="legend" src="/assets/img/leyenda-v2.png" width="180" height="100"/>';
                L.DomEvent.addListener(div, "click", L.DomEvent.stopPropagation)
                    .addListener(div, "click", L.DomEvent.preventDefault)
                    .addListener(div, "click", function () {
                        if (!isViewLegend) {
                            map.removeControl(legendTop);
                            legendBottom.addTo(map);
                            isViewLegend = true;
                        }
                        return div;
                    });
                return div;
            };
            legendTop.addTo(map);
            /** Leyenda que se muestra cuando la principal se encuentra "minimizada" */
            var legendBottom = L.control({ position: "bottomleft" });
            legendBottom.onAdd = function (map) {
                var div = L.DomUtil.create("div", "leaflet-control leaflet-bar");
                var controlUI = L.DomUtil.create("a", "star", div);
                controlUI.title = "Leyenda";
                controlUI.id = "leyenda";
                L.DomEvent.addListener(div, "click", L.DomEvent.stopPropagation)
                    .addListener(div, "click", L.DomEvent.preventDefault)
                    .addListener(div, "click", function () {
                        if (isViewLegend) {
                            map.removeControl(legendBottom);
                            legendTop.addTo(map);
                            isViewLegend = false;
                        }
                        return div;
                    });
                return div;
            };
            // === Se inicializan las propiedades de los iconos de las alertas === //
            this.batteryIcon = L.icon({
                iconUrl: "/assets/img/marcadorBateria.svg",
                shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
                iconSize: [40, 76],
                shadowSize: [45, 45],
                iconAnchor: [20, 57],
                shadowAnchor: [15, 45],
                popupAnchor: [0, -32]
            });
            this.movementIcon = L.icon({
                iconUrl: "/assets/img/marcadorMovimiento.svg",
                shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
                iconSize: [40, 76],
                shadowSize: [45, 45],
                iconAnchor: [20, 57],
                shadowAnchor: [15, 45],
                popupAnchor: [0, -32]
            });
            this.geofenceIcon = L.icon({
                iconUrl: "/assets/img/marcadorGeocerca.svg",
                shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
                iconSize: [40, 76],
                shadowSize: [45, 45],
                iconAnchor: [20, 57],
                shadowAnchor: [15, 45],
                popupAnchor: [0, -32]
            });
            this.speedIcon = L.icon({
                iconUrl: "/assets/img/marcadorVelocidad.svg",
                shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
                iconSize: [40, 76],
                shadowSize: [45, 45],
                iconAnchor: [20, 57],
                shadowAnchor: [15, 45],
                popupAnchor: [0, -32]
            });
            this.shockIcon = L.icon({
                iconUrl: "/assets/img/marcadorImpacto.svg",
                shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
                iconSize: [40, 76],
                shadowSize: [45, 45],
                iconAnchor: [20, 57],
                shadowAnchor: [15, 45],
                popupAnchor: [0, -32]
            });
            this.aidIcon = L.icon({
                iconUrl: "/assets/img/marcadorAuxilio.svg",
                shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
                iconSize: [40, 76],
                shadowSize: [45, 45],
                iconAnchor: [20, 57],
                shadowAnchor: [15, 45],
                popupAnchor: [0, -32]
            });


        });
    },
    beforeCreate() {

        // Marca que está abierta la vista de compartir link
        localStorage.setItem("esCompartirLink", "true");

        // Cuando cierras o recargas la pestaña, lo elimina
        window.addEventListener("beforeunload", () => {
            localStorage.removeItem("esCompartirLink");
        });
        destruirAlerta();

        /** Almacena la URL que accede al sistema*/
        let url = this.$route.path.split('/');
        if (url.length === 4) {
            //URL compuesto de 4 componentes donde: [0]: servidor, [1]: vista, [2]: dispositivo, [3]: token
            sessionStorage.setItem("id", url[2]);
            sessionStorage.setItem("tokenlink", url[3]);

            validar.verificaAcceso(sessionStorage.tokenlink)
                .then(response => {

                    let isValid = false;
                    isValid = response.data;
                    if (isValid === true) {
                        this.getDates();
                        this.obtenerPosiciones();
                        this.obtenerAlertas();
                    } else {
                        generalSweetAlert("Link caducado", "warning");

                        setTimeout(() => {
                            this.$router.push({ name: "Sesion_caducada" });
                        }, 4000);

                    }
                })
                .catch((err) => {
                    console.error("err: ", err);

                    generalSweetAlert("Ocurrio un error en el link compartido", "error");
                    setTimeout(() => {
                        this.$router.push({ name: "Sesion_caducada" });
                    }, 4000);
                });
        } else {
            this.$router.push({
                path: "/aciquicompartirlink"
            });

            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            });
            Toast.fire({
                icon: 'error',
                title: 'Su link de acceso es inválido.'
            });
        }
    },

    methods: {
        /** Función encargada de obtener posiciones del dispositivo*/
        obtenerPosiciones: function () {
            const map = this.$refs.map.mapObject;
            let that = this;

            PosicionesDataService.getPositionByDevicesIdCompartirLink(sessionStorage.id)
                .then((response) => {
                    const decoded = Jwt.jwtDecode(response.data);

                    that.devicePositions = decoded;

                    // Si no hay posiciones registradas
                    if (that.devicePositions.length === 0) {
                        logDeviceInfo(sessionStorage.id);
                        this.$swal.fire({
                            title: "Atención",
                            text: "El dispositivo aún no registra posiciones, espere hasta nuevo movimiento.",
                            icon: "warning"
                        });
                        return; // Evita continuar
                    }

                    // 📍 Limpia marcador previo si existe
                    if (that.markerActual) {
                        map.removeLayer(that.markerActual);
                        that.markerActual = null;
                    }

                    // 📊 Obtener nueva posición
                    const nuevaPos = decoded.map(that.getDisplayPosicion)[0];
                    const color = colorPorEstado(nuevaPos.estado);
                    const info = `${nuevaPos.name} con IMEI: ${nuevaPos.imei}`;
                    logDeviceInfo(info);

                    // 🆕 Crear y agregar marker actualizado
                    that.markerActual = L.marker(
                        [nuevaPos.position.lat, nuevaPos.position.lng],
                        { icon: color }
                    )
                        .addTo(map)
                        .bindPopup(that.contentMarker(nuevaPos));

                    // Centrar el mapa en la nueva posición
                    map.flyTo([nuevaPos.position.lat, nuevaPos.position.lng], 15);

                    // Guardar la posición actual para referencia futura
                    that.devicePositionAux = [nuevaPos];

                    // Actualizar el arreglo de posiciones si coincide el IMEI
                    if (
                        that.devicePositions[0] &&
                        that.devicePositions[0].imei === nuevaPos.imei
                    ) {
                        that.devicePositions[0] = nuevaPos;
                    }

                    // Activar seguimiento de posiciones en tiempo real
                    that.loadNewPositions = true;
                })
                .catch((e) => {
                    console.error("Error en obtener posiciones:: ", e);
                });
        },

        /** Método que obtiene la posición del dispositivo en pantalla */
        getDisplayPosicion(posicion) {
            let estadoPosi = "OFF";
            let options = {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
            };
            if (posicion.tipo == "LAC") {
                posicion.tipo = "LBS";
            }
            if (posicion.estatusMovimiento) {
                estadoPosi = posicion.estatusMovimiento;
            }
            return {
                id: posicion.id,
                name: posicion.dispositivo == null ? "Sin nombre" : posicion.dispositivo.nombre,
                description: new Date(posicion.fechaHoraPosicion).toLocaleDateString(
                    "es-ES",
                    options
                ),
                date_build: "",
                imei: posicion.dispositivo == null ? "Sin imei" : posicion.dispositivo.imei,
                position: {
                    lat: Number.parseFloat(posicion.latitud).toFixed(8),
                    lng: Number.parseFloat(posicion.longitud).toFixed(8),
                },
                usuario: "Desconocido",
                velocidad: posicion.velocidad.toFixed(2),
                knots: posicion.knots.toFixed(2),
                estado: estadoPosi,
                marker: null,
                tiempoEstatico: posicion.tiempoEstatico,
                tiempoOffline: posicion.tiempoOffline,
                tipo: posicion.tipo == null ? "GPS" : posicion.tipo,
            };
        },

        /** Método encargado de crear las etiquetas/campos con 
        * información del dispositivo que alamecenará el popup
        * del dispositivo en el mapa
        */
        contentMarker(datos) {
            return (
                "<b>" +
                datos.name +
                "</b><br><b>Latitud: </b>" +
                datos.position.lat +
                "<br><b>Longitud: </b>" +
                datos.position.lng +
                "<br><b>Tipo: </b>" +
                datos.tipo +
                "<br><b>Velocidad: </b>" +
                datos.velocidad.toString().concat(" Km/h") +
                "<br><b>" + "Nudos" + ": </b>" +
                datos.knots.toString().concat(" m.p.h") +
                "<br><b>Tiempo estadía: </b>" +
                formatoEstadia(datos.tiempoEstatico) +
                "<br><b>Hora última actualización: </b><br>" +
                datos.description +
                " hrs." +
                "<br><b>Tiempo fuera línea: </b><br>" +
                formatoEstadia(datos.tiempoOffline)
            );
        },
        /**  Método que abre y cierra el menú de alertas. */
        openNavAlertas() {
            console.log("entro");

            if (this.banderaMenu) this.closeNav();

            const isOpen = this.banderaMenuDis;
            const width = isOpen ? "0" : "370px";
            const margin = isOpen ? "0" : "370px";

            this.setNavStyle("mySidenavDis", width);
            this.setMainMargin(margin);

            this.banderaMenuDis = !isOpen;
        },
        /** Método que cierra el menú de alertas. */
        setNavStyle(elementId, width) {
            const el = document.getElementById(elementId);
            if (el) el.style.width = width;
        },
        setMainMargin(margin) {
            const main = document.getElementById("main");
            if (main) {
                main.style.marginRight = margin; // Mantenemos el marginRight de tu método viejo
            }
        },
        closeNavDis() {
            document.getElementById("mySidenavDis").style.width = "0";
            this.banderaMenuDis = false;
        },
        /** Método encargado de cambiar el valor de la variable useFilter */
        filters() {
            this.useFilter = !this.useFilter;
        },

        initUnloadListener() {
            globalThis.addEventListener("beforeunload", () => {
                localStorage.removeItem("esCompartirLink");
            });
        },

        /** Método encargado de cambiar el valor de las variables:
        * totalRowsA y currentPage.
        */
        onFiltered(filteredItems) {
            this.totalRowsA = filteredItems.length;
            this.currentPage = 1
        },
        /** Método que obtiene la fecha incial y final del token */
        getDates() {
            let dateStart = Jwt.jwtTest(sessionStorage.getItem('tokenlink')).iat;
            let dateEnd = Jwt.jwtTest(sessionStorage.getItem('tokenlink')).exp;
            sessionStorage.setItem("fechaInicio", dateStart);
            sessionStorage.setItem("fechaFin", dateEnd);
        },


        validacion() {
            const fechaActual = Math.floor(Date.now() / 1000);
            const fechaFin = Number.parseInt(sessionStorage.fechaFin, 10);

            if (fechaActual >= fechaFin) {
                sessionStorage.clear();
                this.$router.push({ name: "Sesion_caducada" });
                return;
            }

            const segundosAntesDeExpirar = 20;
            const tiempoRestanteMs = (fechaFin - fechaActual - segundosAntesDeExpirar) * 1000;

            if (tiempoRestanteMs > 0) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(() => {
                    this.resetCompartirDispositivo();
                }, tiempoRestanteMs);
            }
        },


        async resetCompartirDispositivo() {
            const id = sessionStorage.id;
            const servidor = process.env.VUE_APP_URL_SERVER_BACKEND
            const url = `${servidor}/asincrona/dispositivos/resetCompartir/${id}`;

            try {
                await fetch(url, {
                    method: "GET",
                });
            } catch (err) {
                console.error("Error en resetCompartirDispositivo: ", err)
            }
        },

        /** Método encargado de obtener las alertas del dispositivo */
        obtenerAlertas() {
            AlertasDataService.getAlertasDevice()
                .then((response) => {
                    this.alerts = Jwt.jwtDecode(response.data);

                    this.totalRowsA = this.alerts.length;
                    this.loadAlerts = true;
                })
                .catch((e) => {
                    const s = "401";
                    if (e.toString().includes(s)) {
                        this.$router.push({ name: "Sesion_caducada" });
                    }
                });
        },

        /** Método encargado de visualizar las alertas en el mapa */
        verAlertas(datos) {
            const map = this.$refs.map.mapObject;
            for (let k in this.alerts) {
                if (datos.id == this.alerts[k].id) {

                    if (this.alerts[k].select) {
                        this.alerts[k].select = false;

                        map.removeLayer(this.alertList[datos.id]);
                        this.markers.removeLayer(this.alertList[datos.id]);
                    } else {
                        this.alerts[k].select = true;

                        if (this.alerts[k].tipo == "Geocerca") {
                            var marker = L.marker([datos.latitud, datos.longitud], {
                                icon: this.geofenceIcon,
                            }).addTo(map);
                        }
                        if (this.alerts[k].tipo == "Movimiento") {
                            var marker = L.marker([datos.latitud, datos.longitud], {
                                icon: this.movementIcon,
                            }).addTo(map);
                        }
                        if (this.alerts[k].tipo == "Velocidad") {
                            var marker = L.marker([datos.latitud, datos.longitud], {
                                icon: this.speedIcon,
                            }).addTo(map);
                        }
                        if (this.alerts[k].tipo == "Impacto") {
                            var marker = L.marker([datos.latitud, datos.longitud], {
                                icon: this.shockIcon,
                            }).addTo(map);
                        }
                        if (this.alerts[k].tipo == "Batería baja") {
                            var marker = L.marker([datos.latitud, datos.longitud], {
                                icon: this.batteryIcon,
                            }).addTo(map);
                        }
                        if (this.alerts[k].tipo == "Auxilio") {
                            var marker = L.marker([datos.latitud, datos.longitud], {
                                icon: this.aidIcon,
                            }).addTo(map);
                        }

                        /*
                        * Se crea el popup de la alerta tipo geocerca de manera dependiente
                        * ya que su información es diferente al resto de las alertas.
                        */
                        if (this.alerts[k].tipo == "Geocerca") {
                            marker.bindPopup(
                                "<b>" + "Geocerca" + "</b><br>" +
                                "<b>" + datos.descripcionAlerta + "</b><br>" +
                                "<b>" + "Latitud" + ": </b>" +
                                Number.parseFloat(datos.latitud).toFixed(7) +
                                "<br><b>" + "Longitud" + ": </b>" +
                                Number.parseFloat(datos.longitud).toFixed(7) +
                                "<br><b>" + "Geocerca" + ": </b>" +
                                datos.link
                            ).openPopup();
                            this.markers.addLayer(marker);
                            map.addLayer(this.markers);
                            map.flyTo([datos.latitud, datos.longitud], 16);
                            this.alertList[datos.id] = marker;
                        } else {
                            /*Se crea el popup del resto de las alertas*/
                            marker.bindPopup(
                                "<b>" + this.obtenerTipoAlerta(datos.tipo) + "</b><br>" +
                                "<b>" + "Dispositivo" + ": </b>" +
                                datos.descripcionAlerta +
                                "<br><b>" + "Latitud" + ": </b>" +
                                Number.parseFloat(datos.latitud).toFixed(7) +
                                "<br><b>" + "Longitud" + ": </b>" +
                                Number.parseFloat(datos.longitud).toFixed(7) +
                                "<br><b>" + "Velocidad" + ": </b>" +
                                Number.parseFloat(datos.velocidad).toFixed(2) + " km/h" +
                                "<br><b>" + "Batería" + ": </b>" +
                                datos.bateria
                            ).openPopup();
                            this.markers.addLayer(marker);
                            map.addLayer(this.markers);
                            map.flyTo([datos.latitud, datos.longitud], 16);
                            this.alertList[datos.id] = marker;
                        }
                    }
                }
            }
            this.markers.refreshClusters();
        },
    },
    watch: {
        /**
         *  Obtiene las posiciones de los dispositivos indicados en el intervalo de tiempo solicitado
         */
        loadNewPositions(value) {
            const map = this.$refs.map.mapObject;
            let that = this;

            function obtenerPosicionDispo() {
                PosicionesDataService.getPositionByDevicesIdCompartirLink(sessionStorage.id)
                    .then((response) => {
                        const decoded = Jwt.jwtDecode(response.data);
                        const datos = decoded.map(that.getDisplayPosicion)[0];
                        const color = colorPorEstado(datos.estado);

                        // Borrar marker anterior si existe
                        if (that.markerActual) {
                            map.removeLayer(that.markerActual);
                            that.markerActual = null;
                        }

                        // Crear nuevo marker
                        that.markerActual = L.marker(
                            [datos.position.lat, datos.position.lng],
                            { icon: color }
                        )
                            .addTo(map)
                            .bindPopup(that.contentMarker(datos));

                        // Guardar en auxiliar
                        that.devicePositionAux = [datos];

                        // Actualizar en devicePositions si aplica
                        if (that.devicePositions[0] && that.devicePositions[0].imei === datos.imei) {
                            that.devicePositions[0] = datos;
                        }
                    })
                    .catch(() => {
                        that.loadNewPositions = false;
                    });
            }

            if (value === true) {
                // Ejecutar actualización cada 5 segundos
                this.deviceInterval = setInterval(obtenerPosicionDispo, 5000);

                // Aviso 15 segundos antes de que el link expire
                const linkExpiry = 60 * 1000; // Duración total del link en ms (ajustar según tu lógica)
                const warningTime = 15 * 1000; // 15 segundos antes
                this.linkWarningTimeout = setTimeout(() => {
                    that.$swal({
                        text: "Su link de acceso expirará en 15 segundos.",
                        icon: "warning",
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Aceptar",
                        iconColor: "orange",
                        reverseButtons: true
                    });
                }, linkExpiry - warningTime);
            } else {
                // Limpiar interval y timeout cuando se desactiva
                if (this.deviceInterval) {
                    clearInterval(this.deviceInterval);
                    this.deviceInterval = null;
                }
                if (this.linkWarningTimeout) {
                    clearTimeout(this.linkWarningTimeout);
                    this.linkWarningTimeout = null;
                }

                // Borrar marker actual del mapa
                if (that.markerActual) {
                    map.removeLayer(that.markerActual);
                    that.markerActual = null;
                }

                // Mostrar alerta de link inválido y redirigir
                this.$swal({
                    text: "Su link de acceso es inválido.",
                    icon: "error",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Aceptar",
                    iconColor: "red",
                    reverseButtons: true
                }).then(() => {
                    this.$router.push({ name: "Sesion_caducada" });
                });
            }
        },

        /**
         * Método que consulta el numero de notificaciones guardadas en base de datos cada 30 segundos
         * Obtiene las notificaciones cada que se produce una diferencia para actualizar el submenu de alertas.
         */
        loadAlerts(value) {
            let that = this; // hacemos un bind para poder utilizar variables de vue dentro de una funcion
            function obtenNotificaciones() {
                let countAlerts = 0;
                AlertasDataService.getAlertasDevice()
                    .then((response) => {
                        countAlerts = Jwt.jwtDecode(response.data);
                        if (countAlerts.length > that.totalRowsA) {
                            that.obtenerAlertas();
                        }
                    })
                    .catch((e) => {
                        const s = "401";
                        if (e.toString().includes(s)) {
                            this.$router.push({ name: "Sesion_caducada" });
                        }
                    });
            }
            if (value) {
                // si la bandera loadAlerts es true, ejecuta la funcion obtenerNotificaciones cada 5 segundos
                this.alertsInterval = setInterval(obtenNotificaciones, 5000);
            } else {
                // si la bandera loadAlerts es false, deja de ejecutar la funcion obtenerNotificaciones
                if (this.alertsInterval != null) {
                    clearInterval(this.alertsInterval);
                }
            }
        },


    },

    beforeDestroy() {
        localStorage.removeItem("esCompartirLink");

        if (this.deviceInterval != null) {
            clearInterval(this.deviceInterval);
        }
        if (this.alertsInterval != null) {
            clearInterval(this.alertsInterval);
        }

        clearTimeout(this.timeoutId)
    },

};
</script>

<style>
.divBtn {
    margin-bottom: 0px;
    margin-top: 0px;
    margin-left: 0%;
    margin-right: -10%;
}

.btnMo2 {
    color: white;
    font-weight: 400;
    font-size: 95%;
    justify-content: left;
    margin-bottom: 0px;
    display: flex;
}

.sidenav {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 1;
    top: 0;
    right: 0;
    background-color: white;
    overflow-x: hidden;
    transition: 0.5s;
    padding-top: 60px;
}

.sidenav a {
    padding: 8px 8px 8px 32px;
    text-decoration: none;
    font-size: 25px;
    color: #818181;
    display: block;
    transition: 0.3s;
}

.sidenav a:hover {
    color: #f1f1f1;
}

.sidenav .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
}

#btnX {
    color: #036194;
    display: flex;
    height: 1.8rem;
    margin-top: 5px;
    margin-right: -10px;
}

#btnX:hover {
    color: #002060;
}

@media screen and (max-height: 450px) {
    .sidenav {
        padding-top: 15px;
    }

    .sidenav a {
        font-size: 18px;
    }

    #mapaStyle {
        position: static;
        width: 100%;
        height: 600px;
        z-index: 1;
    }

    #main {
        transition: margin-left 0s;
        padding: 0%;
    }
}

#main {
    transition: margin-left 0.5s;
    padding: 16px;
    height: 100%;
}

#mapaStyle {
    position: static;
    width: 100%;
    height: 800px;
    z-index: 1;
}

@media (max-width: 991.98px) and (max-height: 950px) {
    #main {
        transition: margin-left 0s;
        padding: 14px;
    }

    #mapaStyle {
        position: center;
        height: 600px;
        width: 100%;
        z-index: 1;
    }
}

.layered.box {
    box-shadow: 0 1px 1px hsl(0deg 0% 0% / 0.075),
        0 2px 2px hsl(0deg 0% 0% / 0.075), 0 4px 4px hsl(0deg 0% 0% / 0.075),
        0 8px 8px hsl(0deg 0% 0% / 0.075), 0 16px 16px hsl(0deg 0% 0% / 0.075);
}

.box {
    border-radius: 2px;
    background-color: white;
}

.legend {
    opacity: 0.7;
}

#leyenda {
    background-image: url("../../../assets/images/leyenda.png");
    background-size: 110%;

}

.leaflet-cluster-anim .leaflet-marker-icon,
.leaflet-cluster-anim .leaflet-marker-shadow {
    -webkit-transition: -webkit-transform 0.3s ease-out, opacity 0.3s ease-in;
    -moz-transition: -moz-transform 0.3s ease-out, opacity 0.3s ease-in;
    -o-transition: -o-transform 0.3s ease-out, opacity 0.3s ease-in;
    transition: transform 0.3s ease-out, opacity 0.3s ease-in;
}

.leaflet-cluster-spider-leg {
    /* stroke-dashoffset (duration and function) should match with leaflet-marker-icon transform in order to track it exactly */
    -webkit-transition: -webkit-stroke-dashoffset 0.3s ease-out, -webkit-stroke-opacity 0.3s ease-in;
    -moz-transition: -moz-stroke-dashoffset 0.3s ease-out, -moz-stroke-opacity 0.3s ease-in;
    -o-transition: -o-stroke-dashoffset 0.3s ease-out, -o-stroke-opacity 0.3s ease-in;
    transition: stroke-dashoffset 0.3s ease-out, stroke-opacity 0.3s ease-in;
}

.marker-cluster-small {
    background-color: rgba(181, 226, 140, 0.6);
}

.marker-cluster-small div {
    background-color: rgba(110, 204, 57, 1);
}

.marker-cluster-medium {
    background-color: rgba(241, 211, 87, 0.6);
}

.marker-cluster-medium div {
    background-color: rgba(240, 194, 12, 0.6);
}

.marker-cluster-large {
    background-color: rgba(253, 156, 115, 0.6);
}

.marker-cluster-large div {
    background-color: rgba(241, 128, 23, 0.6);
}

/* IE 6-8 fallback colors */
.leaflet-oldie .marker-cluster-small {
    background-color: rgb(181, 226, 140);
}

.leaflet-oldie .marker-cluster-small div {
    background-color: rgb(110, 204, 57);
}

.leaflet-oldie .marker-cluster-medium {
    background-color: rgb(241, 211, 87);
}

.leaflet-oldie .marker-cluster-medium div {
    background-color: rgb(240, 194, 12);
}

.leaflet-oldie .marker-cluster-large {
    background-color: rgb(253, 156, 115);
}

.leaflet-oldie .marker-cluster-large div {
    background-color: rgb(241, 128, 23);
}

.marker-cluster {
    background-clip: padding-box;
    border-radius: 20px;
}

.marker-cluster div {
    width: 30px;
    height: 30px;
    margin-left: 5px;
    margin-top: 5px;

    text-align: center;
    border-radius: 15px;
    font: 18px "Helvetica Neue", Arial, Helvetica, sans-serif;
    font-weight: bold;
}

.marker-cluster span {
    line-height: 30px;
}
</style>
